import {emptyArray} from '@packages/utilities/fp/utils';
import {
  Component,
  Expressions,
  Plugins,
  type ExpressionPath,
} from '@packages/systems/wfdl';
import {namesEqual, qualify} from '@packages/systems/wfdl-Qualified';
import type {ExpressionElement} from '@packages/systems/wfdl-ast';
import {ALT_PATH} from './constants';

export function getPathsForElement(
  element: ExpressionElement
): ExpressionPath[] {
  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Form'), Component.name('FormButton'))
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'value'},
      ],
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'data-wait'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Form'), Component.name('FormTextInput'))
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'placeholder'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Form'), Component.name('FormTextarea'))
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'placeholder'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Search'), Component.name('SearchInput'))
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'placeholder'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Search'), Component.name('SearchButton'))
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'value'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Basic'), Component.name('Image'))
    )
  ) {
    return [ALT_PATH];
  }

  if (
    namesEqual(
      element.type,
      qualify(
        Plugins.name('Commerce'),
        Component.name('CommerceCartCheckoutButton')
      )
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'value'},
      ],
      [
        {in: 'Record', at: 'commerce'},
        {in: 'Record', at: 'loadingText'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Form'), Component.name('FormRadioInput'))
    )
  ) {
    return [
      [
        {in: 'Record', at: 'attr'},
        {in: 'Record', at: 'value'},
      ],
    ];
  }

  if (
    namesEqual(
      element.type,
      qualify(Plugins.name('Form'), Component.name('FormSelect'))
    )
  ) {
    const formSelectOptionsPath: ExpressionPath = [
      {in: 'Record', at: 'form'},
      {in: 'Record', at: 'opts'},
    ];

    const optionsListExpression = Expressions.getIn(
      Expressions.getElementData(element),
      formSelectOptionsPath
    );

    if (optionsListExpression) {
      const optionsList = Expressions.getList(optionsListExpression);

      if (optionsList) {
        return optionsList.map((_, index) => [
          {in: 'Record', at: 'form'},
          {in: 'Record', at: 'opts'},
          {in: 'List', index},
          {in: 'Record', at: 't'},
        ]);
      }
    }
  }

  return emptyArray;
}
